export interface WidgetConfiguration {
  [key: string]: string | number | boolean
}

/** @public Used in the exported widget API response. */
export interface GetWidgetResponse {
  configuration: WidgetConfiguration
  display_order: number
  id: string
  is_collapsed: boolean
  is_forced?: boolean
  size: string
  widget_key: string
}

export interface GetWidgetsResponse {
  data: GetWidgetResponse[]
}
